import { RateableParticipantDto, UserRatingValue } from "@/api/generated/generatedTypes";
import { USER_RATING_OPTIONS as RATING_OPTIONS } from "@/api/user-rating/dto";
import { Box, Center, Loader, Radio, Table, Text } from "@mantine/core";

type Props = {
  participants: RateableParticipantDto[];
  selectedRatings: Record<string, UserRatingValue>;
  onSelect: (userId: string, value: UserRatingValue) => void;
  isLoading: boolean;
};

function UserRatingSection({ participants, selectedRatings, onSelect, isLoading }: Props) {
  if (isLoading) {
    return (
      <Center py="sm">
        <Loader size="sm" />
      </Center>
    );
  }

  if (participants.length === 0) {
    return (
      <Text c="dimmed" fz="xs" ta="center">
        함께한 게스트 정보를 불러오지 못했어요.
      </Text>
    );
  }

  return (
    <Box>
      <Table withRowBorders={false} verticalSpacing={6} horizontalSpacing={4}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th />
            {RATING_OPTIONS.map((option) => (
              <Table.Th key={option.value} style={{ textAlign: "center" }}>
                <Text fz={10} c="dimmed" fw={500}>
                  {option.label}
                </Text>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {participants.map((participant) => {
            // Ratings are permanent once submitted, so previously rated guests are locked.
            const isLocked = participant.myRating !== null;
            const selectedValue = isLocked
              ? participant.myRating
              : (selectedRatings[participant.userId] ?? null);

            return (
              <Table.Tr key={participant.userId}>
                <Table.Td>
                  <Text fz="xs" c={isLocked ? "dimmed" : "black"} lineClamp={1}>
                    {participant.displayName}
                  </Text>
                </Table.Td>
                {RATING_OPTIONS.map((option) => (
                  <Table.Td key={option.value} style={{ textAlign: "center" }}>
                    <Center>
                      <Radio
                        size="xs"
                        name={`user-rating-${participant.userId}`}
                        value={option.value}
                        checked={selectedValue === option.value}
                        disabled={isLocked}
                        aria-label={`${participant.displayName} ${option.label}`}
                        onChange={() => onSelect(participant.userId, option.value)}
                      />
                    </Center>
                  </Table.Td>
                ))}
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </Box>
  );
}

export default UserRatingSection;
